module.exports = __webpack_public_path__ + "static/media/2_en.a2fb7516.png";